/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb4_HeadingInputs */

const en_visa_eb4_heading = /** @type {(inputs: Visa_Eb4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category-Specific Review`)
};

const pt_visa_eb4_heading = /** @type {(inputs: Visa_Eb4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisão Específica da Categoria`)
};

const es_visa_eb4_heading = /** @type {(inputs: Visa_Eb4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisión Específica de la Categoría`)
};

/**
* | output |
* | --- |
* | "Category-Specific Review" |
*
* @param {Visa_Eb4_HeadingInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb4_heading = /** @type {((inputs?: Visa_Eb4_HeadingInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb4_HeadingInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb4_heading(inputs)
	if (locale === "es") return es_visa_eb4_heading(inputs)
	return en_visa_eb4_heading(inputs)
});